import VideoModalVer2 from 'components/common/VideoModal/ver2';
import GuidelineIframeModal from 'features/to/modals/GuidelineIframeModal';
import useLang from 'hooks/useLang';
import useTheme from 'hooks/useTheme';
import { isEmpty } from 'lodash';
import React, { useState } from 'react';

const withWatchPaytoGuidelineOptional = (Component) => {
  const WatchPaytoGuidelineOptionalComponent = (props) => {
    const { isShowIframeModal } = props || {};

    const { t } = useLang();
    const { isHHMTTheme } = useTheme();

    const [isShowGuidelineModal, setShowGuidelineModal] = useState(false);
    const [modalOptions, setModalOptions] = useState(null);

    const onShowWatchPaytoGuideline = (modalOptions) => {
      setShowGuidelineModal(true);
      setModalOptions(modalOptions);
    };
    const onCloseWatchPaytoGuideline = () => {
      setShowGuidelineModal(false);
    };

    const renderWatchPaytoGuidelineModal = () => {
      if (!isShowGuidelineModal) return null;
      if (isShowIframeModal)
        return (
          <GuidelineIframeModal
            isShow={isShowGuidelineModal}
            modalOptions={modalOptions}
            actionClose={onCloseWatchPaytoGuideline}
          />
        );
      return (
        <VideoModalVer2
          isOpen={isShowGuidelineModal}
          onClose={onCloseWatchPaytoGuideline}
          modalOptions={{
            iframeSrc: isHHMTTheme
              ? t('link_payto_guideline_hhmt_video')
              : t('link_payto_guideline_remox_video'),
            ...modalOptions,
          }}
          isBackdropOverlap={!isEmpty(modalOptions)}
          zIndexBackdropOverlap={1202}
        />
      );
    };

    const newProps = {
      ...props,
      onShowWatchPaytoGuideline,
    };
    return (
      <>
        {renderWatchPaytoGuidelineModal()}
        <Component {...newProps} />
      </>
    );
  };
  return WatchPaytoGuidelineOptionalComponent;
};

export default withWatchPaytoGuidelineOptional;
